var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "accent",
    d: "M17.75 8.415c.33.329.33.853 0 1.17l-3.683 3.683a.828.828 0 0 1-1.17-.024.824.824 0 0 1 0-1.159l2.268-2.268H6.079a.83.83 0 0 1-.829-.83c0-.45.378-.828.83-.828h9.072l-2.268-2.257a.828.828 0 0 1 1.146-1.195c.6.6 3.72 3.708 3.72 3.708Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.805 3.707V1.695H1.659v14.61h7.146v-2.012c0-.464.378-.854.83-.854.45 0 .828.378.828.854v2.146c0 .866-.683 1.561-1.536 1.561h-7.39A1.551 1.551 0 0 1 0 16.439V1.561C0 .695.683 0 1.537 0h7.402c.841 0 1.537.695 1.537 1.561v2.146c0 .464-.378.854-.83.854a.843.843 0 0 1-.829-.854h-.012Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.0c45ae3e4f148b8889515b3f9cf0b1d0.svg";
export { ForwardRef as ReactComponent };